// extracted by mini-css-extract-plugin
export var black = "s-module--black--3ffe2";
export var darkGrey = "s-module--darkGrey--0dacc";
export var darkpurple = "s-module--darkpurple--1652f";
export var green = "s-module--green--c6bec";
export var grey = "s-module--grey--5b5eb";
export var lightGrey = "s-module--lightGrey--67e93";
export var lightGrey2 = "s-module--lightGrey2--82549";
export var lightGrey3 = "s-module--lightGrey3--ed36f";
export var lightblue = "s-module--lightblue--742da";
export var lightorange = "s-module--lightorange--5b330";
export var neongreen = "s-module--neongreen--52e19";
export var orange = "s-module--orange--de45a";
export var pink = "s-module--pink--fa149";
export var purple = "s-module--purple--82443";
export var red = "s-module--red--a2ab6";
export var rvGrey100 = "s-module--rvGrey100--aa4e4";
export var rvGrey200 = "s-module--rvGrey200--cfcb1";
export var rvGrey300 = "s-module--rvGrey300--e4ef2";
export var rvGrey400 = "s-module--rvGrey400--79f8a";
export var rvGrey500 = "s-module--rvGrey500--30d13";
export var rvGreydiff = "s-module--rvGreydiff--3ae1e";
export var rvOrange = "s-module--rvOrange--068a1";
export var rvYellow = "s-module--rvYellow--fcab3";
export var white = "s-module--white--3dfcc";
export var yellow = "s-module--yellow--65672";